import React from 'react';
import { ImageTitle } from '../../core/ImageTitle';
import { GenericListControl } from '../../controls/SimpleListControl';
import { ApiDataAccess } from '../../infrastructure/ApiDataAccess';


export class StandardProductInvalidPricingView extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            items: null
        };

        this.apiDataAccess = new ApiDataAccess('data/standard-product');
    }

    
    componentDidMount() {
        this.loadData();       
    }

    async loadData() {
        var items = await this.apiDataAccess.get('/pricing/invalid');
        this.setState({ items: items });
        console.log('CCCCCC', items);
    }



    render() {
        return (
            <div className="view">
                <ImageTitle text='Invalid Pricing' />

                <GenericListControl
                    items={this.state.items}
                    onRenderTitle={() => {
                        return (
                            <div className='row'>
                                <div className='col col-4'>Name</div>
                            </div>                            
                        )
                    }}
                    onRender={(item, idx) => {
                        return (
                            <div className='row' key={`row_${idx}`}>
                                <div className='col col-4'><a href={`/standard-products/${item.id}/pricing`}>{item.name}</a></div>
                            </div>                    
                        )
                    }}
                />

            </div>
        );
    }
}